import { AxiosPromise } from 'axios';
import { proxyAPI } from '../httpClient';

const shieldSettings = {
  fetchIsDamageProtectionEnabled: (accountId: string): AxiosPromise =>
    proxyAPI.get(`gfh-shield-setting-service/accounts/${accountId}/is-enabled`),
};

export default shieldSettings;
